import Vue from "vue";

import PressReleases from "./PressReleases.vue";

export function load() {
    const selector = "press-releases";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PressReleases, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
